import React from 'react';
import { Card, CardContent, Typography, Tooltip, Box } from '@mui/material';

const AccuracyMetricsCard = ({ 
  title, 
  value, 
  subtitle, 
  color = 'primary', 
  suffix = '',
  numerator,
  denominator,
  tooltipContent,
  icon: Icon
}) => {
  let displayValue;
  
  if (numerator !== undefined && denominator !== undefined) {
    // Show percentage big with fraction below
    displayValue = (
      <Box>
        <Typography variant="h3" component="div" sx={{ fontWeight: 600 }}>
          {value !== null && value !== undefined ? Math.round(value) : 0}%
        </Typography>
        <Typography variant="body1" component="div" sx={{ mt: 0.5, color: 'text.secondary', fontWeight: 500 }}>
          {numerator} / {denominator}
        </Typography>
      </Box>
    );
  } else {
    // Original display format
    displayValue = value !== null && value !== undefined 
      ? `${Number.isInteger(value) ? value : value.toFixed(2)}${suffix}` 
      : 'N/A';
  }

  const cardContent = (
    <Card sx={{ height: '100%', cursor: tooltipContent ? 'help' : 'default' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          {Icon && <Icon sx={{ fontSize: 20, color: 'primary.main' }} />}
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
            {title}
          </Typography>
        </Box>
        <Box
          sx={{ 
            fontWeight: 600,
            color: `${color}.main`,
            mb: 1
          }}
        >
          {typeof displayValue === 'string' ? (
            <Typography variant="h3" component="div">
              {displayValue}
            </Typography>
          ) : (
            displayValue
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );

  if (tooltipContent) {
    return (
      <Tooltip 
        title={tooltipContent} 
        arrow 
        placement="top"
        sx={{ cursor: 'help' }}
      >
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
};

export default AccuracyMetricsCard;

